// Page copy for the redesigned Studio. Keep enUS and zhCN structurally identical.
export const enUS = {
  title: 'Profile',
  cardLabel: 'Profile details',
  personalAccount: 'Personal account',
  emailAddress: 'Email address',
  signInMethod: 'Sign-in method',
  methods: {
    email: 'Email',
    google: 'Google',
    github: 'GitHub',
  },
  note: 'Your profile is connected to your sign-in account',
  password: {
    label: 'Password',
    manage: 'Set or reset password',
    description: 'Verify your account email to set a password or reset an existing one.',
    newPlaceholder: 'Create a new password',
    confirmPlaceholder: 'Re-enter new password',
    sessionNote: 'You’ll stay signed in. Your Google or GitHub sign-in will still work.',
    next: 'New password',
    confirm: 'Confirm new password',
    requirements: 'At least 8 characters, up to 72 bytes.',
    save: 'Save password',
    updating: 'Updating…',
    newRequired: 'Enter a new password.',
    confirmRequired: 'Confirm your new password.',
    minLength: 'Use at least 8 characters.',
    maxLength: 'Use no more than 72 bytes.',
    mismatch: 'The new passwords do not match.',
    policy: 'This password does not meet the requirements. Choose a different password.',
    code: 'Verification code',
    codeRequired: 'Enter the six-digit code from your email.',
    codeInvalid: 'This code is invalid or expired. Try again or request a new code.',
    codeSent: 'A six-digit code has been sent to your email. It is valid for 5 minutes.',
    sendCode: 'Send verification code',
    sending: 'Sending…',
    resend: 'Resend code',
    resendIn: 'Resend ({seconds}s)',
    sendFailedTitle: 'Unable to send code',
    sendFailed: 'The code could not be sent. Complete the security check and try again.',
    rateLimited: 'Too many requests. Wait 60 seconds, then try again.',
    securityLoading: 'Loading security check…',
    securityFailed: 'The security check could not load. Please retry.',
    securityRequired: 'Complete the security check again to request a code.',
    emailMissing: 'This account has no email address. Contact Support to set a password.',
    pendingTitle: 'Password update pending',
    pending: 'Your password update is awaiting confirmation. Try signing in with your new password, or contact Support before trying again.',
    failed: 'Unable to save password',
    tryAgain: 'The password could not be updated. Please try again.',
    success: 'Password saved successfully',
  },
}

export const zhCN = {
  title: '个人资料',
  cardLabel: '资料详情',
  personalAccount: '个人账户',
  emailAddress: '邮箱地址',
  signInMethod: '登录方式',
  methods: {
    email: '邮箱',
    google: 'Google',
    github: 'GitHub',
  },
  note: '你的资料与登录账户绑定',
  password: {
    label: '密码',
    manage: '设置或重置密码',
    description: '验证账户邮箱，即可首次设置密码或重置已有密码。',
    newPlaceholder: '设置一个新密码',
    confirmPlaceholder: '再次输入新密码',
    sessionNote: '设置后将保持登录，原有 Google 或 GitHub 登录方式不受影响。',
    next: '新密码',
    confirm: '确认新密码',
    requirements: '至少 8 个字符，总长度不超过 72 字节。',
    save: '保存密码',
    updating: '正在更新…',
    newRequired: '请输入新密码。',
    confirmRequired: '请再次输入新密码。',
    minLength: '密码至少需要 8 个字符。',
    maxLength: '密码总长度不能超过 72 字节。',
    mismatch: '两次输入的新密码不一致。',
    policy: '该密码不符合要求，请换一个密码。',
    code: '验证码',
    codeRequired: '请输入邮件中的 6 位数字验证码。',
    codeInvalid: '验证码无效或已过期，请检查后重试或重新发送。',
    codeSent: '6 位数字验证码已发送至你的邮箱，5 分钟内有效。',
    sendCode: '发送验证码',
    sending: '正在发送…',
    resend: '重新发送',
    resendIn: '{seconds} 秒后重新发送',
    sendFailedTitle: '无法发送验证码',
    sendFailed: '验证码发送失败，请完成人机校验后重试。',
    rateLimited: '请求过于频繁，请等待 60 秒后重试。',
    securityLoading: '正在加载人机校验…',
    securityFailed: '人机校验加载失败，请重试。',
    securityRequired: '请重新完成人机校验，再发送验证码。',
    emailMissing: '此账户没有邮箱地址，请联系 Support 设置密码。',
    pendingTitle: '密码更新等待确认',
    pending: '密码更新结果正在确认中。请尝试使用新密码登录，或联系 Support 确认后再试。',
    failed: '无法保存密码',
    tryAgain: '未能更新密码，请重试。',
    success: '密码保存成功',
  },
}
